/* eslint-disable jira/filename-case */
export const CREATED = 201;
export const NO_CONTENT = 204;

export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const PROXY_AUTHENTICATION_REQUIRED = 407;
export const REQUEST_TIMEOUT = 408;
export const CONFLICT = 409;

export const PRECONDITION_FAILED = 412;
export const CONTENT_TOO_LARGE = 413;
export const UNPROCESSABLE_ENTITY = 422;
export const UPGRADE_REQUIRED = 426;
export const TOO_MANY_REQUESTS = 429;
export const INTERNAL_SERVER_ERROR = 500;
export const BAD_GATEWAY = 502;
export const SERVICE_UNAVAILABLE = 503;
export const GATEWAY_TIMEOUT = 504;
